import * as React from "react";
import { Clipboard, ExternalLink } from "react-feather";
import { DOCS_URL } from "../../envVariables";

export const SupportDocs: React.FC = () => {
  async function handleCopyToClipboard(value: string) {
    navigator.clipboard.writeText(value);
  }

  return (
    <div className="flex justify-center gap-4 my-6">
      <div>
        <div className="font-semibold text-sm">Support Email</div>
        <div className="flex items-center gap-1">
          <a className="color-link-hover" href={`mailto:support@controlplane.com`}>
            support@controlplane.com
          </a>
          <Clipboard
            className="feather-icon cursor-pointer color-link-hover"
            onClick={() => handleCopyToClipboard(`support@controlplane.com`)}
          />
        </div>
      </div>
      <div>
        <div className="font-semibold text-sm">Documentation</div>
        <div className="flex items-center gap-1">
          <div className={`flex items-center`}>
            <a className="truncate color-link-hover" href={DOCS_URL} target={"_blank"} rel={`noopener`}>
              <span>{DOCS_URL}</span>
              <ExternalLink className={`inline-block feather-icon ml-1`} style={{ transform: "translateY(2px)" }} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
